import makeStyles from '@mui/styles/makeStyles';

const default_color_error = "#f04438";
const hide_color = "#03569E";

const styles = makeStyles(theme => ({
  contactTitle: {
    color: "#465869",
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "24px"
  },
  phoneInputColumn: {
    width: "fit-content !important",
    alignSelf: "center",
    "& > input": {
      border: "none !important",
      boxShadow: "none !important",
      background: "transparent !important",
      "&:hover": {
        border: "none !important"
      }
    },
    "& .flag-dropdown": {
      "& .flag": {
        "& .arrow": {
          display: "none !important"
        }
      }
    }
  },
  actionsWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10
  },
  button: {
    whiteSpace: "nowrap",
    width: "100%"
  },
  hideFormButton: {
    backgroundColor: hide_color,
    color: "#fff"
  },
  errorMessage: {
    color: default_color_error
  }
}));

export default styles;
